'use strict';
import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';
import _ from 'lodash';

import notificationsHtmlUrl from 'ioToolViews/directives/notifications.html';
import uploadProgressHtmlUrl from 'ioToolViews/directives/uploadProgress.html';
import detailedOrdersCardHtmlUrl from '../../modules/orders/views/detailedOrders_card.html';

angular.module('app.directives', []);

angular.module('app.directives')

.directive('dynamicForm', [function() {
    return {
        restrict: 'A',
        link: function(scope, el, attrs) {
            $.core.main.dynamicForm(el);

            $('footer #form-save').click(function() {
                $.core.main.hideFooter();
            });

            $('footer #form-close').click(function() {
                $.core.main.hideFooter();
            });
        }
    }
}])
    .directive('showErrors', function() {
        return {
            restrict: 'A',
            require: '^form',
            link: function(scope, el, attrs, formCtrl) {
                // find the text box element, which has the 'name' attribute
                var inputEl = el[0].querySelector("[name]");
                // convert the native text box element to an angular element
                var inputNgEl = angular.element(inputEl);
                // get the name on the text box so we know the property to check
                // on the form controller
                var inputName = inputNgEl.attr('name');

                // only apply the has-error class after the user leaves the text box
                scope.$on('show-errors-check-validity', function() {
                    el.toggleClass('has-error', formCtrl[inputName].$invalid);
                });

                inputNgEl.bind('blur', function() {
                    if (!formCtrl[inputName].$invalid) {
                        el.toggleClass('has-error', formCtrl[inputName].$invalid);
                    }
                });
            }
        }
    })
    /*.directive('loader', function() {
        return {
            restrict: 'E',
            templateUrl: 'views/directives/loader.html'
        }
    })*/
    .directive('numeric', function() {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function(scope, element, attrs, ngModel) {
                if (!ngModel) return;
                ngModel.$parsers.unshift(function(inputValue) {
                    var digits = inputValue.split('').filter(function(s) {
                        return (!isNaN(s) && s != ' ');
                    }).join('');
                    ngModel.$viewValue = digits;
                    ngModel.$render();
                    return digits;
                });
            }
        }
    })
    .directive("csDateToIso", function() {
        var linkFunction = function(scope, element, attrs, ngModelCtrl) {
            ngModelCtrl.$parsers.push(function(datepickerValue) {
                return moment(datepickerValue).format("YYYY-MM-DD");
            });
        };
        return {
            restrict: "A",
            require: "ngModel",
            link: linkFunction
        };
    })
    .directive('phoneFormat', function() {
        var changeFunction = function(scope, element, attrs, ngModelCtrl) {
            var $phoneText = "";
            element.keydown(function(e) {
                var key = e.charCode || e.keyCode || 0;
                $phoneText = $(this);

                // Auto-format- do not expose the mask as the user begins to type
                if (key !== 8 && key !== 9) {
                    if ($phoneText.val().length === 0) {
                        $phoneText.val('(');
                    }
                    if ($phoneText.val().length === 4) {
                        $phoneText.val($phoneText.val() + ')');
                    }
                    if ($phoneText.val().length === 5) {
                        $phoneText.val($phoneText.val() + ' ');
                    }
                    if ($phoneText.val().length === 9) {
                        $phoneText.val($phoneText.val() + '-');
                    }
                }

                // Allow numeric (and tab, backspace, delete) keys only
                return (key == 8 ||
                    key == 9 ||
                    key == 46 ||
                    (key >= 48 && key <= 57) ||
                    (key >= 96 && key <= 105));
            })

            .bind('focus click', function() {

                $phoneText = $(this);

                if ($phoneText.val().length === 0) {
                    $phoneText.val('(');
                } else {
                    var val = $phoneText.val();
                    $phoneText.val('').val(val); // Ensure cursor remains at the end
                }
            })

            .blur(function() {
                $phoneText = $(this);

                if ($phoneText.val() === '(') {
                    $phoneText.val('');
                }
            });

        };
        return {
            restrict: "A",
            require: "ngModel",
            link: changeFunction
        };
    })
    .directive('currencyFormat', ['$timeout', function($timeout) {
        var changeFunction = function(scope, element, attrs, ngModelCtrl) {

            element.keyup(function(e) {
                if (e.keyCode > 36 && e.keyCode < 41) {
                    return true;
                }
                this.value = formating(this.value);
            });

            $timeout(function() {
                let eleVal = angular.element(element).val();
                eleVal = eleVal.replace('$', ''); // remove '$' symbol
                eleVal = formating(eleVal, true);
                angular.element(element).val(eleVal);
            }, 500);

            function formating(eleVal, trimming) {
                const original = eleVal;
                if (eleVal) {
                    eleVal = eleVal.replace(/,/g, "");
                    if (trimming===true){
                        eleVal = parseFloat(eleVal).toFixed(2);
                    }
                    let numVal = eleVal.split(".");
                    if (numVal.length >= 2) {
                        numVal[0] = numVal[0].replace(/[^0-9]/gi, '');
                        numVal[1] = numVal[1].replace(/[^0-9]/gi, '');
                        numVal[0] = numVal[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                        numVal[1] = numVal[1].substring(0,2);
                        eleVal = numVal[0] + "." + numVal[1];
                    } else {
                        eleVal = eleVal.replace(/[^0-9]/gi, '');
                        eleVal = eleVal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                    }
                    if (eleVal && !eleVal.contains('$')) {
                        const str = "$";
                        eleVal = str.concat(eleVal);
                    }
                    if (original.contains('-')) {
                        eleVal = '-' + eleVal;
                    }
                }
                return eleVal;
            }
        }
        return {
            restrict: "A",
            require: "ngModel",
            link: changeFunction
        };
    }])
    .directive('numberFormat', ['$timeout', 'FieldTransformer', function($timeout, FieldTransformer) {
        var changeFunction = function(scope, element, attrs, ngModelCtrl) {

            element.keyup(function(e) {
                if (e.keyCode > 36 && e.keyCode < 41) {
                    return true;
                }
                this.value = FieldTransformer.transformNumber(this.value);
            });

            $timeout(function() {
                const eleVal = FieldTransformer.transformNumber(angular.element(element).val());
                angular.element(element).val(eleVal);
            }, 500);
        }
        return {
            restrict: "A",
            require: "ngModel",
            link: changeFunction
        };
    }])
    .directive('signIntegerFormat', ['$timeout', 'FieldTransformer', function($timeout, FieldTransformer) {
        var changeFunction = function(scope, element, attrs, ngModelCtrl) {

            element.keyup(function(e) {
                console.log(e.keyCode);
                if (e.keyCode > 36 && e.keyCode < 41) {
                    return true;
                }
                const sign = this.value.charAt(0) === '+' ? '+' : '';
                this.value = sign + FieldTransformer.transformNumber(this.value);
            });

            $timeout(function() {
                let eleVal = angular.element(element).val();
                const sign = eleVal.charAt(0) === '+' ? '+' : '';
                eleVal = sign + FieldTransformer.transformNumber(eleVal);
                angular.element(element).val(eleVal);
            }, 500);
        }
        return {
            restrict: "A",
            require: "ngModel",
            link: changeFunction
        };
    }])
    .directive('decimalFormat', function() {
        var changeFunction = function(scope, element, attrs, ngModelCtrl) {
            element.keyup(function(e) {
                if ((e.keyCode >= 48 && e.keyCode <=57) || (e.keyCode >= 96 && e.keyCode <=105)) {
                    return true;
                }
                return false;
            })
        }
        return {
            restrict: "A",
            require: "ngModel",
            link: changeFunction
        };
    })
    .directive('percentageFormat', ['$timeout', function($timeout) {
        var changeFunction = function(scope, element, attrs, ngModelCtrl) {
            element.keyup(function(e) {
                if ((e.keyCode >= 48 && e.keyCode <=57) || (e.keyCode >= 96 && e.keyCode <=105)) {
                    return true;
                }
                return false;
            })

            $timeout(function() {
                let value = angular.element(element).val();
                if (value.length > 0 && !value.contains('%')) {
                    value = value.concat("%");
                    angular.element(element).val(value);
                }
            }, 500);

            element.blur(function(e){
                if (this.value.length > 0 && !this.value.contains('%')) {
                    this.value = this.value.concat("%");
                    return true;
                }
            })
        }
        return {
            restrict: "A",
            require: "ngModel",
            link: changeFunction
        };
    }])
    .directive('exportTable', function() {
        return {
            restrict: 'A',
            link: function(scope, elem, attr) {
                scope.$on('export-pdf',
                    function(e, d) {
                        elem.tableExport({
                            type: 'pdf',
                            escape: false
                        });
                    });
                scope.$on('export-excl',
                    function(e, d) {
                        elem.tableExport({
                            type: 'excel',
                            escape: 'false'
                        });
                    });
                scope.$on('export-doc',
                    function(e, d) {
                        elem.tableExport({
                            type: 'doc',
                            escape: false
                        });
                    });
            }
        };
    })
    .directive('datepickerLocaldate', ['$parse', function($parse) {
        var directive = {
            restrict: 'A',
            require: ['ngModel'],
            link: link
        };
        return directive;

        function link(scope, element, attr, ctrls) {
            var ngModelController = ctrls[0];

            // called with a 'yyyy-mm-dd' string to format
            ngModelController.$formatters.push(function(modelValue) {
                if (!modelValue) {
                    return undefined;
                }
                // date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
                var dt = new Date(modelValue);
                // 'undo' the timezone offset again (so we end up on the original date again)
                dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
                return dt;
            });
        }
    }])
    .directive('notifications', function() {
        return {
            restrict: 'EA',
            templateUrl: notificationsHtmlUrl,
            scope: {
                notificationsData: '=',
                refreshNotifications: '&',
                toggled: '&',
                openNotification: '&'
            },
            link: function(scope, element, attr) {

            }
        }
    })
    //This directive allows us to dynamicly change the labels on the tabs for angular-utils-pagination
    .directive('pageLabel', ['PageNumberService', function(PageNumberService) {
        return {
            restrict: 'E',
            scope: {
                labelNumber: '='
            },
            template: '<span style="display: block">{{pageName}}</span>',
            link: function(scope, el, attrs) {
                if (scope.labelNumber && scope.labelNumber >= 0) {
                    scope.pageName = PageNumberService.pages[scope.labelNumber - 1].text;
                } else {
                    scope.pageName = scope.labelNumber;
                }
            }
        }
    }])
    .directive('noDirty', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                ngModelCtrl.$setDirty = angular.noop;
            }
        }
    })
    .directive('uploadProgress', function() {
        return {
            restrict: 'EA',
            templateUrl: uploadProgressHtmlUrl,
            scope: {
                notificationsData: '='
            },
            link: function(scope, element, attr) {

                scope.clear = function() {
                    if(scope.notificationsData) {
                        for(let i in scope.notificationsData){
                            if (scope.notificationsData[i].value < 100) {
                                scope.notificationsData[i].upload.abort();
                                let fileName = scope.notificationsData[i].name;
                                let message = 'File ' + fileName + ' uploading has been Cancelled';
                                scope.notificationsData[i].ioAlert.show('', message, 'error');
                            }
                        }
                        scope.notificationsData = [];
                    }
                }

                scope.cancel = function(fileName) {
                    if(scope.notificationsData) {
                        for(let i in scope.notificationsData){
                            if (scope.notificationsData[i].name == fileName) {
                                scope.notificationsData[i].upload.abort();
                                let message = 'File ' + fileName + ' uploading has been Cancelled';
                                scope.notificationsData[i].ioAlert.show('', message, 'error');
                                scope.notificationsData.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
            }
        }
    })
    .directive('arrayRequired', function() {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                if (attrs && attrs.arrayRequired == 'true') {
                    ctrl.$validators.uiSelectRequired = function(modelValue, viewValue) {

                        var determineVal;
                        if (angular.isArray(modelValue)) {
                            determineVal = modelValue;
                        } else if (angular.isArray(viewValue)) {
                            determineVal = viewValue;
                        } else {
                            return false;
                        }

                        return determineVal.length > 0;
                    };
                }

            }
        };
    })
    .directive('autoResize', ['$timeout', function($timeout) {
        const changeFunction = function(scope, element, attrs, ngModelCtrl) {
            // Default height 98
            // Max rows for default height 5
            const factor = (98-1)/5.0;
            const resize = function() {
                const value = angular.element(element).val();
                const rows = value.split("\n").length
                const height = rows * factor;
                element.css('height', height + 'px');
            }

            // remove scroll bar
            element.css('overflow', 'hidden');
            // reset textarea when init
            $timeout(function() {
                resize();
            }, 500);

            element.keyup(function(e) {
                resize();
            })
        }
        return {
            restrict: "A",
            require: "ngModel",
            link: changeFunction
        };
    }])
